import axios from 'axios'
const Axios = {
  install: function (Vue, options) {
    // axios.defaults.withCredentials = true
    // axios.defaults.xsrfHeaderName = "X-CSRF-Token"
    // axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
    Vue.prototype.$axios = axios
  }
}
export default Axios
